import { assignInlineVars } from '@vanilla-extract/dynamic';
import { ProfileSectionProps } from './types';
import { StringPreview } from './StringPreview';
import * as styles from './MobilePreview.css';
import { toImgSrc } from '@client/new/common/media.helpers';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

export const instagramLabel = (
  <span>
    <Icon icon={faInstagram} /> Instagram
  </span>
);

export const tiktokLabel = (
  <span>
    <Icon icon={faTiktok} /> TikTok
  </span>
);

export const youtubeLabel = (
  <span>
    <Icon icon={faYoutube} /> YouTube
  </span>
);

export const ProfileSection = ({
  profile,
  primaryColor,
}: ProfileSectionProps) => {
  const avatarUrl = `url(${toImgSrc(profile.mediaAvatar)})`;

  return (
    <div style={{ padding: '0 12px' }}>
      <div
        className={styles.avatar}
        style={assignInlineVars({
          [styles.avatarImageVar]: avatarUrl,
        })}
      />
      <div>
        <div className={styles.name}>
          {profile.firstName || 'Name'} {profile.lastName || 'Surname'}
        </div>
        <div className={`${styles.title} ${styles.titleContainer}`}>
          <StringPreview value={profile.title || ''} name="Title" maxLen={50} />
        </div>
        <div
          className={`${styles.socials} ${styles.socialsContainer}`}
          style={assignInlineVars({
            [styles.colorVar]: primaryColor,
          })}
        >
          {profile.profileInstagram && instagramLabel}
          {profile.profileYoutubeChannel && youtubeLabel}
          {profile.profileTiktok && tiktokLabel}
        </div>
      </div>
    </div>
  );
};
